import {useContext} from 'react';
import {UserContext} from '../contexts/UserContext';

export default function usePermissionGranted(...permissions: (string | string[])[]): boolean {
    const userContext = useContext(UserContext);

    return !permissions.length || userContext != null && userContext.canAny(...permissions);
}
